<script>
import Layout from "../../../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { InboundOrderPath } from "@/path.js";
import Swal from "sweetalert2";
import viewDetails from "./view.vue";

export default {
    components : {
        Layout,
        PageHeader,
        'view-details' : viewDetails
    },
    data(){
        return {
            title: "Production",
            items: [
                {
                    text: "List",   
                },
                {
                    text: "Stock",
                    active: true,
                },
            ],
            key : 1,
            filter : [],
            fields : ['item','stock_available','no_of_batches','actions'],
            data : [],
            baseUrl : process.env.VUE_APP_API_BACKEND_URL,
            search : '',
            currentPage : 1,
            selectedOrder : null,
            type : 'gravies',
            selectedData : null
        }
    },
    mounted () {
        this.getOrders();
    },
    watch : {
        type(){
            this.getOrders();
        },
        currentPage(){
            this.getOrders();
        }
    },
    methods : {
        reload(){
            this.getOrders();
            this.selectedOrder = null;
        },
        addOrder(){
            this.$bvModal.show('add');
            this.key += 1;
        },
        viewData(v){
            this.selectedData = v;
            this.$bvModal.show('view-details');
        },
        async getOrders(){
            try {
                let res = await axios.get(this.baseUrl + InboundOrderPath.GET_STOCK_DETAILS,{
                    params : {
                        page : this.currentPage,
                        search : this.search,
                        type : this.type
                    }
                });
                if(res.data.status){
                    this.data = res.data.data;
                }
            } catch (error) {
                console.log(error);
            }
        },
        rowClass(item,type){
            if (!item || type !== 'row') return
            if (item.status === 'pending') return 'table-light'
            if(item.status == 'completed') return 'table-success'
            if(item.status == 'progress') return 'table-warning'
        },
        onRowSelected(v){
            this.selectedOrder = v; 
            this.$bvModal.show('add');
        },
        async deleteData(order){
            try {
                let res = await axios.post(this.baseUrl + InboundOrderPath.DELETE_ORDER,{
                    order_id : order.id
                });
                if(res.data.status){
                    Swal.fire("Success","",'success');
                    this.getOrders();
                }
            } catch (error) {
                console.log(error);
                Swal.fire(error.message,"",'error');
            }
        },
        async setStatus(v){
            try {
                if(v.status == 'completed'){
                    Swal.fire('Sorry Cannot be edited once it is completed',"",'error');
                    return;
                }
                let res = await axios.post(this.baseUrl + InboundOrderPath.UpdateStatus,{
                    order_id : v.id,
                    status : v.status == 'pending' ? 'progress' : (v.status == 'progress' ? 'completed' : 'completed')
                });
                if(res.data.status){
                    Swal.fire("Updated Successfully","","success");
                    this.getOrders();
                }
            } catch (error) {
                console.log(error);
            }
        }
    }
}
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-card>
            <b-card-header>
                
            </b-card-header>
            <b-card-body>
                <b-modal size="xl" id="view-details" hide-footer>
                    <view-details :type="type" :obj="selectedData"></view-details>
                </b-modal>
                <b-tabs>
                    <b-tab title="Gravies" @click="(() => type = 'gravies')" active></b-tab>
                    <b-tab title="Packaging" @click="(() => type = 'packaging')"></b-tab>
                </b-tabs>
                <div class="flex float-right">
                    <label>Search</label>
                    <b-input v-model="search" @change="getOrders"></b-input>
                </div>
                <div class="table-responsive">
                    <b-table
                        :key="data.key"
                        :items="data.data"
                        :fields="fields"
                        responsive="sm"
                        :filter="filter"
                        :current-page="currentPage"
                    >
                        <template v-slot:cell(stock_available)="row">
                            {{ row.item.total_qty }} {{ type == 'gravies' ? row.item.units : '' }}
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-button variant="success" @click="viewData(row.item)"><i class="fa fa-eye"></i></b-button>
                        </template>
                    </b-table>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                            <!-- pagination -->
                            <b-pagination :key="data.key" v-model="currentPage" :total-rows="data.total" :per-page="data.per_page"></b-pagination>
                        </ul>
                        </div>
                    </div>
                </div>
            </b-card-body>
        </b-card>
    </Layout>
</template>

<style>

</style>